import { useRef, useState } from 'react';
import * as Popper from '@popperjs/core';
import { useEffectSync } from './useEffectSync/useEffectSync';

export function usePopper(options: Parameters<typeof Popper.createPopper>[2]): {
  referenceElement: HTMLElement | null;
  popperElement: HTMLElement | null;
  setReferenceElement: (instance: HTMLElement | null) => void;
  setPopperElement: (instance: HTMLElement | null) => void;
  popperInstance: Popper.Instance | null;
} {
  const optionsRef = useRef(options);
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(
    null
  );
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);
  const popperInstanceRef = useRef<Popper.Instance | null>(null);

  useEffectSync(() => {
    let createdInstance: Popper.Instance | null = null;
    if (referenceElement && popperElement) {
      createdInstance = Popper.createPopper(
        referenceElement,
        popperElement,
        optionsRef.current
      );
    }

    popperInstanceRef.current = createdInstance;

    return () => {
      createdInstance?.destroy();
    };
  }, [referenceElement, popperElement, popperInstanceRef, optionsRef]);

  return {
    referenceElement,
    popperElement,
    setReferenceElement,
    setPopperElement,
    popperInstance: popperInstanceRef.current
  };
}
